export default function getUserTimeZoneRegion() {
	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	if (!timeZone) return { timeZone: null, region: 'unknown' };

	let region = 'other';

	if (timeZone.startsWith('America/')) {
		region = 'america';
	} else if (timeZone.startsWith('Europe/')) {
		region = 'europe';
	}

	return {
		timeZone, // Пример: "America/Chicago"
		region // "america", "europe" или "other"
	};
}
